"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// DEPRECATED
// Delete once clients move to CallLayout.tsx
var react_1 = __importStar(require("react"));
var VideoStream_1 = __importDefault(require("./VideoStream"));
var Pip_1 = __importStar(require("./Pip"));
var core_1 = require("@material-ui/core");
var signaling_1 = require("../../signaling");
var constants_1 = require("./constants");
var Popout_1 = __importDefault(require("../Popout/Popout"));
var PresentationPopoutButton_1 = __importDefault(require("./PresentationPopoutButton"));
var clsx_1 = __importDefault(require("clsx"));
var styles = {
    remoteVideo: {
        boxSizing: 'border-box',
        height: "100%",
        objectFit: 'contain',
        width: "100%"
    },
    minimizedRemoteVideo: {
        height: 'auto',
        borderRadius: '5px'
    }
};
var useStyles = core_1.makeStyles(function () { return ({
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    pipHolder: {
        display: 'flex',
        flex: "0 0 " + (constants_1.videoSmallHeight + constants_1.margin) + "px",
        flexDirection: 'column-reverse',
        paddingLeft: constants_1.margin,
        position: 'absolute'
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        height: "calc(var(--vh, 1vh) * 100 - " + (constants_1.reservedFooter + constants_1.reservedHeader) + "px)"
    },
    compositeContainer: {
        flex: "1 1 auto",
        height: 0,
        objectFit: 'contain',
        padding: "0 " + constants_1.margin + "px",
        position: 'relative',
        width: "100%"
    },
    popoutButton: {
        bottom: constants_1.margin,
        fontSize: '12px !important',
        left: constants_1.margin,
        position: 'absolute',
        zIndex: 1000
    },
    compositeWithSlider: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 0
    },
    presentationWithSlider: function (props) { return ({
        position: 'relative',
        width: (props === null || props === void 0 ? void 0 : props.presentationWidth) + "px!important",
        top: 0
    }); }
}); });
function CompositedLayout(props) {
    var _a, _b;
    var _c;
    var _d = props.isMobileView, isMobileView = _d === void 0 ? false : _d, _e = props.muteRemotes, muteRemotes = _e === void 0 ? false : _e, _f = props.presentationName, presentationName = _f === void 0 ? 'Presentation' : _f, _g = props.showPip, showPip = _g === void 0 ? false : _g, isMinimized = props.isMinimized, Slider = props.Slider, videoLayout = props.videoLayout;
    var remoteStreams = signaling_1.hooks.useRemoteStreams();
    var _h = signaling_1.hooks.useMedia(), localPresentationStream = _h.localPresentationStream, remotePresentationStream = _h.remotePresentationStream, localVideoMuted = _h.localVideoMuted;
    var localPrimaryStream = signaling_1.hooks.useLocalPrimaryStream();
    // composited view, there should be only 1 remote stream, and it should have a video track always. let's find it in the list.
    // in weird cases, on some systems, in p2p calls, we may get 2 streams, 1 audio 1 video.
    // we show the video one in this component.
    // currently the webclient shows the audio only ones in an audio stream component.
    // this logic should be consolidated either in the SDK or webclient components, and the underlying root cause should be solved
    // the fix is likely in the SDK -- waiting to create an offer after getting both the audio and video tracks settled on the peer connection.
    // there may be race conditions or media stream ID issues WRT VBB and getting the tracks on the peer connection under 1 stream id.
    var remoteStream = remoteStreams.find(function (s) { return !!(s === null || s === void 0 ? void 0 : s.getVideoTracks()[0]); });
    var _j = react_1.useState(true), largePresentation = _j[0], setLargePresentation = _j[1];
    var _k = react_1.useState(false), isHovering = _k[0], setIsHovering = _k[1];
    var presentationLayout = signaling_1.hooks.useMedia().presentationLayout;
    var presentationInLayout = !!remotePresentationStream && presentationLayout !== signaling_1.constants.SFU_PRES_LAYOUT_POPPEDOUT;
    var presentationIsPopped = !!remotePresentationStream && presentationLayout === signaling_1.constants.SFU_PRES_LAYOUT_POPPEDOUT;
    var isSliderVisible = presentationInLayout && !presentationIsPopped && Slider && !isMinimized;
    var classes = useStyles(isSliderVisible ? { presentationWidth: (_c = videoLayout === null || videoLayout === void 0 ? void 0 : videoLayout.videoSecondary) === null || _c === void 0 ? void 0 : _c.container } : {});
    react_1.useEffect(function () {
        if (remotePresentationStream) {
            setLargePresentation(true);
        }
    }, [remotePresentationStream]);
    if (!remoteStreams.length) {
        return (react_1.default.createElement("div", { className: classes.wrapper },
            react_1.default.createElement("div", { className: classes.compositeContainer, id: "composited-remote-holder" },
                react_1.default.createElement(VideoStream_1.default, { dataTestId: 'local-video', elementId: 'localVideo', style: styles.remoteVideo, mediaStream: localPrimaryStream.stream, muted: true, hidden: false, mirror: !localPrimaryStream.isEnvironmentFacing }))));
    }
    var showLargePresentation = remotePresentationStream && !presentationIsPopped && largePresentation;
    var showPipPresentation = remotePresentationStream && !presentationIsPopped && !largePresentation;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.wrapper },
            react_1.default.createElement("div", { className: classes.pipHolder, id: "composited-pip-holder" },
                localPresentationStream && showPip && (react_1.default.createElement(Pip_1.default, { animate: false, dataTestId: 'pip-local-presentation', elementId: 'pip-presentation', pipType: Pip_1.PipType.pres, stream: localPresentationStream })),
                !isMinimized && remotePresentationStream && !presentationIsPopped && (react_1.default.createElement(react_1.default.Fragment, null,
                    !isSliderVisible && !showPipPresentation && (react_1.default.createElement(Pip_1.default, { animate: false, dataTestId: 'pip-remote', elementId: "pip-remoteStream", hidden: !largePresentation, muted: muteRemotes, onClick: function () { return setLargePresentation(false); }, pipType: Pip_1.PipType.pip, stream: remoteStream })),
                    !isSliderVisible && showPipPresentation && (react_1.default.createElement(Pip_1.default, { animate: false, dataTestId: 'pip-presentation', elementId: "pip-remotePresentation", hidden: largePresentation, muted: muteRemotes, onClick: function () { return setLargePresentation(true); }, pipType: Pip_1.PipType.pres, stream: remotePresentationStream })))),
                showPip && (react_1.default.createElement(Pip_1.default, { animate: false, dataTestId: 'pip-local', displayName: localPrimaryStream.displayName, elementId: 'localVideo', mirror: !localPrimaryStream.isEnvironmentFacing, pipType: Pip_1.PipType.pip, stream: localPrimaryStream.stream, videoMuted: localVideoMuted }))),
            react_1.default.createElement("div", { className: clsx_1.default(classes.compositeContainer, (_a = {}, _a[classes.compositeWithSlider] = isSliderVisible, _a)), id: "composited-remote-holder", onMouseEnter: function () { return setIsHovering(true); }, onMouseLeave: function () { return setIsHovering(false); } },
                showLargePresentation && !isMinimized && (react_1.default.createElement(VideoStream_1.default, { dataTestId: 'remote-presentation-video-large', elementId: 'remotePresentation', muted: muteRemotes, mediaStream: remotePresentationStream, style: __assign(__assign({}, (largePresentation ? styles.remoteVideo : { display: 'none' })), (remotePresentationStream && isSliderVisible ? { width: videoLayout.videoSecondary.width, display: 'block' } : {})), className: clsx_1.default((_b = {}, _b[classes.presentationWithSlider] = isSliderVisible, _b)) })),
                (!showLargePresentation || isMinimized || isSliderVisible) && (react_1.default.createElement(VideoStream_1.default, { dataTestId: 'remote-video', elementId: 'remoteVideo', muted: muteRemotes, mediaStream: remoteStream, style: __assign(__assign(__assign({}, styles.remoteVideo), (isMinimized && styles.minimizedRemoteVideo)), (isSliderVisible && {
                        width: videoLayout.videoPrimary.width
                    })) })),
                presentationInLayout && !isMobileView && !isMinimized && (react_1.default.createElement(PresentationPopoutButton_1.default, { className: classes.popoutButton, isVisible: isHovering, intl: props.intl })))),
        remotePresentationStream && presentationLayout === signaling_1.constants.SFU_PRES_LAYOUT_POPPEDOUT && (react_1.default.createElement(Popout_1.default, { windowName: presentationName })),
        isSliderVisible && Slider));
}
exports.default = CompositedLayout;
